module.exports = __webpack_public_path__ + "img/close.902f9a9f.svg";